// extracted by mini-css-extract-plugin
export default {"item":"Item_item__CTgsO","active":"Item_active__wzsD9","head":"Item_head__fAHEJ","body":"Item_body__Z8V0i","button":"Item_button__xQFr6"};